<template>
  <div class="order-list tt-custom-tab">
    <ARTICLE v-if="cur_articleId" :articleId="cur_articleId"></ARTICLE>
  </div>
</template>

<script>
//import Mail from './MailBody.vue'
import api from '../../services/api.js'
import { API_HOST } from '../../services/constant.js'
import ARTICLE from '../../components/ArticleDetail'

let _ = require('lodash')

export default {
  name: 'OrderList',
  data() {
    return {
      API_HOST:API_HOST,
      account_id:this.$localStorage.get('account_id'),
      cur_articleId:''
    }
  },
  created () {
    this.cur_articleId=this.$route.query.id;
  },
  components:{
    ARTICLE
  },
  mounted() {
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .article_card{
    display: flex;
    margin-bottom:10px;
    padding-bottom:10px;
    border-bottom:1px solid #ccc;
  }
.empty-content {
  padding: 50px 0 50px;
}
.drag-upload{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width:1150px;
  height:300px;
  border:2px dashed #ccc;
  border-radius: 4px;
  background:rgb(247,247,247);
}
.add-picture{
  width:100px;
  height:100px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  border:1px solid #ccc;
  border-radius: 4px;
  background:rgb(247,247,247);
  margin-bottom:10px;
}
.add-picture-img{
  position:relative;
  margin-left:12px;
  margin-bottom:10px;
  border:1px solid #ccc;
  border-radius: 4px;
}
.editor_tag{
  height:28px;
  display: inline-block;
  line-height: 20px;
  padding: 4px 10px;
  background:rgb(247,247,247);
  border-radius: 4px;
  color:#333;
}
.huatidialog{
  position:fixed;
  z-index:9999;
  border:1px solid #ccc;
  box-shadow: #ccc;
  padding:10px;
  width:390px;
  height: 190px;
  background: white;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/articles/Detail.vue